import React,{ useEffect, useState, useContext } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap"
import { FaAlignCenter, FaUserTie } from "react-icons/fa";
import { Link } from 'react-router-dom';
import language from '../img/icons/translate.svg'
import globe from '../img/icons/world.svg'
import doctor from '../img/icons/bag.svg'
import office from '../img/icons/estetoscope.svg'
import group from '../img/icons/people.svg'
import religion from '../img/icons/library.svg'
import Get from '../api/Get'
import GetAll from '../api/GetAll'
import { COMPANY_ALL,
    ESPECIALITIES_LIST,
    ACCOUNT_ALL,
    COUNTRY_ALL,
    LANGUAGE_ALL,
    RELIGIONES_ALL,
    PARTNER_LIST_ACTIVE,
    PROVIDER_ALL,
    STATES_ALL,
    MUNICIPIO_ALL,
    MARITAL_STATUS_ALL,
    PACIENTERELACION_GET_ALL,
    GET_PLANES
} from "../api/Routes";
import { authContext } from "../context/AuthContext";
import LoadingList from "../loader/LoadingList";
import { withTranslation } from "react-i18next";
import { RiSurveyLine, RiUserStarLine } from "react-icons/ri";
import { ImUsers } from "react-icons/im";
import { HiOutlineUsers, HiOutlineViewGridAdd } from "react-icons/hi";
import ComponentModalErrorSever from "./ComponentModalErrorSever";
import useCompanyType from "../hook/useCompanyType";


function DashboardAdmin({t, url}) {
    const [companias, setCompanias] = useState(0)
    const [especialidades, setEspecialidades] = useState(0)
    const [cuentas, setCuentas] = useState(0)
    const [paises, setPaises] = useState(0)
    const [idiomas, setIdiomas] = useState(0)
    const [religiones, setReligiones] = useState(0)
    const [partners, setPartners] = useState(0)
    const [loading, setLoading] = useState(false)
    const [providers, setProviders] = useState(0)
    const [estados, setEstados] = useState(0)
    const [municipios, setMunicipios] = useState(0)
    const [maritalStatus, setMaritalStatus] = useState(0)
    const [tipoPaciente, setTipoPaciente] = useState(0)
    const [tipoPlan, setTipoPlan] = useState(0)
    const [encuesta, setEncuesta] = useState(0)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const companyType = useCompanyType()

    
    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    useEffect(() => {
        setLoading(true)
        Get({url: COMPANY_ALL, access_token: accesToken})
        .then((resp) => {            
            let data = resp.data.data.response;
            setCompanias(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: ESPECIALITIES_LIST, access_token: accesToken}).then((resp) => {
            let data = resp.data.data.response;
            setEspecialidades(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: ACCOUNT_ALL, access_token: accesToken}).then((resp) => {
            let data = resp.data.data.response;
            setCuentas(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: COUNTRY_ALL, access_token: accesToken}).then((resp) => {
            let data = resp.data.data.response;
            setPaises(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: LANGUAGE_ALL, access_token: accesToken}).then((resp) => {
            let data = resp.data.data.response;
            setIdiomas(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: RELIGIONES_ALL, access_token: accesToken}).then((resp) => {
            //console.log(resp)
            let data = resp.data.data.response;
            setReligiones(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])


    useEffect(() => {
        setLoading(true)
        Get({url: PARTNER_LIST_ACTIVE, access_token: accesToken}).then((resp) => {
            let data = resp.data.data.response;
            setPartners(data.length)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    useEffect(() => {
        let urls = [PROVIDER_ALL, STATES_ALL, MARITAL_STATUS_ALL, GET_PLANES]
        GetAll({urls: urls, access_token: auth.data.access_token})
        .then(response=>{
            setProviders(response[0].data.data.response.numberOfElements)
            setEstados(response[1].data.data.response.numberOfElements)
            setMaritalStatus(response[2].data.data.response.numberOfElements)
            setTipoPlan(response[3].data.data.response.length)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

    useEffect(() => {
        Get({url: MUNICIPIO_ALL, access_token: accesToken})
        .then((resp) => {
            setMunicipios(resp.data.data.response.numberOfElements)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        Get({url: PACIENTERELACION_GET_ALL, access_token: accesToken}).then((resp) => {
            let data = resp.data;
            setTipoPaciente(data.numberOfElements)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    return(<>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
        {loading && <LoadingList texto='' />}
        <Container fluid className="mt-5">
            <Row>
                <Col xs="12" md="12" >            
                    <Row>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/company`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{companias}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('companias')}</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={office} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/specialties`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{especialidades}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('especialidades')}</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={doctor} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/cuentas`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{cuentas}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('cuentas')}</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={group} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/country`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{paises}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('paises')}</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={globe} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/estados`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{estados}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Estados</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={globe} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/municipios`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{municipios}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Municipios</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={globe} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/language`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{idiomas}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('idiomas')}  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={language} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/religiones`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{religiones}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('Religion')}  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Image src={religion} fluid className="height-da-50"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/partners`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{partners}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">{t('cliente_corporativo')}  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <FaUserTie className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/proveedores`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{providers}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Proveedores  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <RiUserStarLine className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/estadocivil`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{maritalStatus}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Estado civil  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <ImUsers className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/tipopaciente`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{tipoPaciente}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Tipo paciente  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <HiOutlineUsers className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        {companyType === 'colombia' && 
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/tipoplan`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <span className="text-color-1 text-secondary d-block cursor-pointer">{tipoPlan}</span>
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Tipo de plan</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <HiOutlineViewGridAdd className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>}
                        {companyType === 'colombia' &&
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/diagnosticos`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                {/* <span className="text-color-1 text-secondary d-block cursor-pointer">{tipoPaciente}</span> */}
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Diagnósticos  </label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <FaAlignCenter className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>}
                        <Col xs="12" md="4" className="mb-3">
                            <Link to={`${url}/encuesta`} className="no-underline">
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center text-center text-md-left">
                                            <Col xs="12" md="8">
                                                <label className="mb-0 font-weight-bold d-block cursor-pointer text-dark">Encuesta</label>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <RiSurveyLine className="icon-catalogue"/>
                                            </Col>
                                        </Row>
                                        
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    </Row>                   
                </Col>                
            </Row>
        </Container>
    </>)
}

export default withTranslation()(DashboardAdmin)